/**
 * @generated SignedSource<<bb3d35cdad8f93a028bcb2ef99782fc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClientAccountGroupInput = {
  accountGroupId: any;
  clientId: any;
};
export type AccountGroupAccordion_DeactivateClientAccountGroupMutation$variables = {
  input: DeleteClientAccountGroupInput;
};
export type AccountGroupAccordion_DeactivateClientAccountGroupMutation$data = {
  readonly DeactivateClientAccountGroup: {
    readonly accountGroup: {
      readonly accounts: ReadonlyArray<{
        readonly financialAccountId: number;
        readonly id: any;
      }>;
      readonly id: string;
      readonly name: string;
    } | null;
  };
};
export type AccountGroupAccordion_DeactivateClientAccountGroupMutation = {
  response: AccountGroupAccordion_DeactivateClientAccountGroupMutation$data;
  variables: AccountGroupAccordion_DeactivateClientAccountGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ClientUserPayload",
    "kind": "LinkedField",
    "name": "DeactivateClientAccountGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountGroup",
        "kind": "LinkedField",
        "name": "accountGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "financialAccountId",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountGroupAccordion_DeactivateClientAccountGroupMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountGroupAccordion_DeactivateClientAccountGroupMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e09c2bf0c08d36c154964af302768b03",
    "id": null,
    "metadata": {},
    "name": "AccountGroupAccordion_DeactivateClientAccountGroupMutation",
    "operationKind": "mutation",
    "text": "mutation AccountGroupAccordion_DeactivateClientAccountGroupMutation(\n  $input: DeleteClientAccountGroupInput!\n) {\n  DeactivateClientAccountGroup(input: $input) {\n    accountGroup {\n      accounts {\n        financialAccountId\n        id\n      }\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e95bf870f268ce3f4be722d6f264a3f9";

export default node;
